import * as AEM from "./AEM";
import * as SSR from "./SSR";

const Renders = {
    ...AEM,
    ...SSR
};

export default Renders;
